export const allRights = "© All rights reserved 2023";
export const phoneNumber = "+7 495 772 95 90 (12615)";
